export default __webpack_public_path__ + "static/media/FormDCertificate.612c2340.png";